import { render, staticRenderFns } from "./ChildSelect.vue?vue&type=template&id=0bbaa6dd&"
import script from "./ChildSelect.vue?vue&type=script&lang=js&"
export * from "./ChildSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports